import { useTheme } from '../lib/theme-provider';
import { Monitor, Moon, Sun } from 'lucide-react';

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const options = [
    { value: 'light' as const, icon: Sun, label: 'Light mode' },
    { value: 'dark' as const, icon: Moon, label: 'Dark mode' },
    { value: 'system' as const, icon: Monitor, label: 'System preference' },
  ];

  return (
    <div role="radiogroup" aria-label="Color theme" className="inline-flex rounded-xl bg-surface-sunken p-1 gap-1">
      {options.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          role="radio"
          aria-checked={theme === value}
          aria-label={label}
          onClick={() => setTheme(value)}
          className={`
            p-2 rounded-lg transition-all duration-200 cursor-pointer
            focus-visible:outline-2 focus-visible:outline-offset-2
            focus-visible:outline-edge-focus
            ${
              theme === value
                ? 'bg-surface-raised text-content-primary shadow-sm'
                : 'text-content-tertiary hover:text-content-secondary'
            }
          `}
        >
          <Icon className="h-4 w-4" aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
